import { render, staticRenderFns } from "./TheMainCard.vue?vue&type=template&id=c18752f8&scoped=true&"
import script from "./TheMainCard.vue?vue&type=script&lang=ts&"
export * from "./TheMainCard.vue?vue&type=script&lang=ts&"
import style0 from "./TheMainCard.vue?vue&type=style&index=0&id=c18752f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18752f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
